/** @deprecated старый URL для файлов EPZ */
export const EPZ_OLD_URL = 'https://epz.iltumen.ru/uploads/';

/** новый URL для файлов EPZ */
export const EPZ_URL = 'https://epzpub.iltumen.ru/data/';

export const getEpzFileUrl = (path, recentPlenarySessions) => {
	if (!path) return '';
	const meetingId = String(path).split('/')[0];
	const useOldUrl = (recentPlenarySessions || []).some(
		session => session.meetingId != null && String(session.meetingId) === meetingId,
	);
	return (useOldUrl ? EPZ_OLD_URL : EPZ_URL) + path;
};
